import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { ComponentsComponent } from './components/components.component';
import { AuthGuard } from './service/auth/auth.guard';
import { RoleGuardService as RoleGuard } from './service/auth/role-guard.service';

import { SigninComponent } from './widget/signin/signin.component';
import { SignupComponent } from './widget/signup/signup.component';
import { UserListComponent } from './route/user/user-list/user-list.component';
import { Error403Component } from './widget/error403/error403.component';
import { Error404Component } from './widget/error404/error404.component';
import { ForgetPasswordComponent } from './widget/forget-password/forget-password.component';
import { ResponseResetComponent } from './widget/response-reset/response-reset.component';
import { ProfileComponent } from './widget/profile/profile.component';
import { InscriptionListComponent } from './route/inscription/inscription-list/inscription-list.component';
import { InscriptionAddComponent } from './route/inscription/inscription-add/inscription-add.component';
import { InscriptionEditComponent } from './route/inscription/inscription-edit/inscription-edit.component';
import { InscriptionScanComponent } from './route/inscription/inscription-scan/inscription-scan.component';
import { AccueilComponent } from './route/accueil/accueil.component';

const routes: Routes = [
  /*{ path: '', redirectTo: 'home', pathMatch: 'full' },*/
  { path: '', redirectTo: 'accueil', pathMatch: 'full' },
  { path: 'error403', component: Error403Component },
  { path: 'signin', component: SigninComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'forgetPassword', component: ForgetPasswordComponent },
  { path: 'accueil', component: AccueilComponent },
  { path: 'home', component: ComponentsComponent, canActivate: [AuthGuard] },
  { path: 'profil', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'user/list', component: UserListComponent, canActivate: [AuthGuard] },
  { path: 'inscription/list', component: InscriptionListComponent, canActivate: [AuthGuard] },
  { path: 'inscription/add/:type', component: InscriptionAddComponent, canActivate: [AuthGuard] },
  { path: 'inscription/edit/:id', component: InscriptionEditComponent, canActivate: [AuthGuard] },
  { path: 'inscription/scan', component: InscriptionScanComponent, canActivate: [AuthGuard] },
  { path: 'error404', component: Error404Component },
  { path: 'response-reset-password/:token', component: ResponseResetComponent },
  { path: '**', redirectTo: '/error404' }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
